import React, { memo } from 'react';
import { Col, Row } from 'reactstrap';
import { getNoVehicleImageToDisplay } from 'site-modules/shared/utils/get-no-vehicle-image-to-display';

export const PreviewEmpty = memo(function PreviewEmpty() {
  const errorImage = getNoVehicleImageToDisplay();

  return (
    <div className="preview-card preview-card-empty bg-white rounded-24 pos-r px-1 py-1_25 py-md-1 mx-auto">
      <Row className="gx-2 align-items-center flex-wrap flex-md-nowrap">
        <Col xs={12} md="auto mb-1 mb-md-0">
          <img src={errorImage} alt="" className="d-block m-auto vehicle-image rounded-20" />
        </Col>
        <Col
          xs={12}
          md="auto"
          className="preview-card-details justify-content-center d-flex flex-column gap-0_25 flex-shrink-1 align-items-center align-items-md-start"
        >
          <h2 className="size-20 mb-0">Selected Deal</h2>
          <h3 className="preview-title text-cool-gray-10 size-24 fw-bold mb-0 text-center text-md-start">
            Deal no longer available
          </h3>
          <p className="text-cool-gray-30 size-18 mb-0 text-center text-md-start">
            Looks like this lease deal is no longer available. Don&rsquo;t worry, you can still browse our latest offers
            below.
          </p>
        </Col>
      </Row>
    </div>
  );
});
